/* __next_internal_client_entry_do_not_use__ SDUIViewportHandler auto */ import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useGetCurrentSDUIClientSize } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Viewport/useGetCurrentSDUIClientSize";
import React from "react";
export var SDUIViewportHandler = function(param) {
    var _param_viewports = param.viewports, viewports = _param_viewports === void 0 ? [] : _param_viewports, children = param.children;
    var sduiClientSize = useGetCurrentSDUIClientSize();
    if (viewports.length > 0 && !viewports.includes(sduiClientSize)) {
        return null;
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
